export default "__VITE_ASSET__DqC1PWZq__"